jQuery(document).ready(function () {

    // birth dates - we dont want a date picker as it is very cumbersome to click back 20 years
    // but native ui on mobiles would be great
    if (Modernizr.touchevents && Modernizr.inputtypes.date) {
        // make iOS and Android use native timepicker
        jQuery('.birthdate input, input.birthdate').prop('type', 'date');
    } else {
        // localize date, it comes as ISO from Django
        jQuery('.birthdate input, input.birthdate').each(function () {
            var d = new Date(jQuery(this).val());
            if (!isNaN(d.getTime())) {
                // TODO: i18n
                var date_string_de = ("0" + d.getDate()).slice(-2) + '.' + ("0" + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
                jQuery(this).val(date_string_de);
            }
        });
    }
});


// WEBPACK FOOTER //
// ./private/js/birthdate.js